import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import actions from './actions';

import ListaAcoes from '../../components/ListaAcoes';
import constants from '../admin/constants';

class MeusRegistros extends Component {
  render () {
    const { value, actions } = this.props;

    return (<div><ListaAcoes
      tipo="meusRegistros"
      value={value}
      actions={{
        onLoad: actions.onLoadMeusRegistros,
        onCancel: actions.onChangeListProblema(
          constants.Status.CANCELADA
        ),
        onApprove: actions.onChangeListProblema(
          constants.Status.CONFIRMADA
        ),
        onCreate: actions.onChangeListProblema(
          constants.Status.CONFIRMADA
        )
      }}
      labelFn={item => <details><summary>
        {moment(item.created_at).format('DD/MM/YYYY HH:mm')} : {item.local} » {item.sublocal}<br />
        {item.categoria} » {item.subcategoria}
      </summary>
      {item.observacao}
      </details>}
    /><br /></div>);
  }
}

let mapStateToProps = ({ problema: { meusRegistros } }) => ({
  value: meusRegistros
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MeusRegistros);



// WEBPACK FOOTER //
// ./src/modules/problema/ListaMeusRegistros.js